import React, { useRef, useEffect } from 'react';
import { Rect, Text as KonvaText, Circle, Line, Transformer } from 'react-konva';

export const ResizableShape = ({ shapeProps, isSelected, onSelect, onChange, shapeType }) => {
  const shapeRef = useRef();
  const trRef = useRef();

  useEffect(() => {
    if (isSelected && trRef.current && shapeRef.current) {
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  const handleDragEnd = (e) => {
    onChange({ ...shapeProps, x: e.target.x(), y: e.target.y() });
  };

  const handleTransformEnd = () => {
    const node = shapeRef.current;
    const scaleX = node.scaleX();
    const scaleY = node.scaleY();
    node.scaleX(1);
    node.scaleY(1);

    if (shapeType === 'circle') {
      onChange({ ...shapeProps, x: node.x(), y: node.y(), radius: Math.max(5, shapeProps.radius * Math.max(scaleX, scaleY)) });
    } else if (shapeType === 'text') {
      onChange({ ...shapeProps, x: node.x(), y: node.y(), fontSize: Math.max(8, shapeProps.fontSize * scaleY), width: node.width() * scaleX });
    } else {
      onChange({ ...shapeProps, x: node.x(), y: node.y(), width: Math.max(5, node.width() * scaleX), height: Math.max(5, node.height() * scaleY) });
    }
  };

  const commonProps = {
    ref: shapeRef,
    ...shapeProps,
    draggable: !shapeProps.locked,
    onClick: onSelect,
    onTap: onSelect,
    onDragEnd: handleDragEnd,
    onTransformEnd: handleTransformEnd,
  };

  return (
    <>
      {shapeType === 'rect' && <Rect {...commonProps} />}
      {shapeType === 'circle' && <Circle {...commonProps} />}
      {shapeType === 'text' && <KonvaText {...commonProps} />}
      {shapeType === 'line' && <Line {...commonProps} onTransformEnd={handleDragEnd} />}
      {isSelected && !shapeProps.locked && (
        <Transformer
          ref={trRef}
          flipEnabled={false}
          boundBoxFunc={(oldBox, newBox) => {
            if (Math.abs(newBox.width) < 5 || Math.abs(newBox.height) < 5) return oldBox;
            return newBox;
          }}
        />
      )}
    </>
  );
};
